import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import { Card1, Card2 } from 'components/Card';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SaibaMais = () => {
    const { isMobile } = useDevice();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <Grid container
            style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-around',
                maxHeight: isMobile ? '100%' : '100%',
                fontFamily: 'Open sans',
                flexDirection: isMobile ? 'column' : '',
                margin: isMobile ? '' : '2em 0 5em'
            }}>
            <Grid item xs={12}>
                <IconButton onClick={handleBack} style={{ position: '', top: 20, left: 20, zIndex: 999 }}>
                    <ArrowBackIcon style={{ color: 'var(--azul)' }} />
                </IconButton>
            </Grid>
            <Grid item xs={12} md={5} xl={4} lg={5}
                style={{
                    textAlign: 'justify',
                    padding: isMobile ? '2em 2em' : '',
                    fontSize: isMobile ? '12px' : '16px',
                }}>
                <h1
                    style={{
                        color: 'var(--azul)',
                        fontSize: '1.6em',
                        fontWeight: 600
                    }}>Destinação Diretamente ao Fundo</h1>
                <p>
                    Os contribuintes (Pessoa Física), a qualquer tempo, podem doar bens e/ou recursos aos Fundos da Criança e do Adolescente e deduzir até 6% do imposto sobre a renda, apurado na Declaração de Imposto sobre a Renda da Pessoa Física (DIRPF);
                </p>
                <p>
                    As empresas, tributadas pelo lucro real, a qualquer tempo, podem doar bens e/ou recursos aos Fundos da Criança e do Adolescente e deduzir até 1% do imposto sobre a renda apurado (mensal, trimestral ou anual).
                </p>
                <h1
                    style={{
                        color: 'var(--azul)',
                        fontSize: '1.6em',
                        fontWeight: 600
                    }}>Destinação Por meio da DIRPF</h1>
                <p>
                    Os contribuintes (Pessoa Física) podem destinar até 3% do imposto de renda apurado na Declaração de Ajuste Anual do Imposto de Renda de Pessoa Física (DIRPF).
                </p>
            </Grid>
            <Grid item xs={12} md={5} xl={4} style={{
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <Card1 />
                <Card2 />
            </Grid>
        </Grid>
    )
}

export default SaibaMais;
